export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/threeD_product_animation.f0b0b18.svg";